import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { verifyAndGetForm } from '../../services/api'
import { useLocalizedNavigate } from '../../hooks/useLocalizedNavigate'
import { useAuth } from '../../contexts/AuthContext'

export default function Home() {
  const { t } = useTranslation()
  const navigate = useLocalizedNavigate()
  const { user } = useAuth()
  const [formId, setFormId] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => { document.title = `${t('common.appName')} — ${t('home.subtitle')}` }, [t])

  const handleAccessForm = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!formId.trim()) {
      setError(t('home.enterFormId'))
      return
    }

    setLoading(true)
    setError('')

    try {
      await verifyAndGetForm(formId.trim(), password)
      sessionStorage.setItem(`form_${formId}_password`, password)
      navigate(`/dashboard/${formId}`)
    } catch (err) {
      setError(err instanceof Error ? err.message : t('errors.accessError'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="container">
      <div style={{ maxWidth: '500px', margin: '3rem auto' }}>
        <div className="text-center mb-4">
          <h1 className="sr-only">{t('common.appName')}</h1>
          <p className="text-gray">{t('home.subtitle')}</p>
        </div>

        <div className="card">
          <h2>{t('home.accessExisting')}</h2>
          <form onSubmit={handleAccessForm}>
            <div className="form-group">
              <label className="form-label" htmlFor="home-form-id">{t('home.formId')}</label>
              <input
                id="home-form-id"
                type="text"
                className="form-input"
                value={formId}
                onChange={(e) => setFormId(e.target.value)}
                placeholder={t('home.formIdPlaceholder')}
                dir="ltr"
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="home-password">{t('home.managementPassword')}</label>
              <input
                id="home-password"
                type="password"
                className="form-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={t('home.passwordPlaceholder')}
              />
            </div>

            {error && <p className="text-danger text-sm mb-2" role="alert">{error}</p>}

            <button type="submit" className="btn btn-primary w-full" disabled={loading}>
              {loading ? (
                <FontAwesomeIcon icon="spinner" className="spinner" />
              ) : (
                <>
                  <FontAwesomeIcon icon="lock" />
                  {t('home.accessForm')}
                </>
              )}
            </button>
          </form>

          <div style={{ textAlign: 'center', margin: '1.5rem 0', color: 'var(--gray-500)' }}>
            - {t('home.or')} -
          </div>

          <button className="btn btn-primary w-full" onClick={() => navigate('/create')}>
            <FontAwesomeIcon icon="plus" />
            {t('home.createNew')}
          </button>

          {!user && (
            <div style={{ textAlign: 'center', marginTop: '1rem', padding: '0.75rem', background: '#f0fdf4', borderRadius: 'var(--radius)', border: '1px solid #bbf7d0' }}>
              <p className="text-sm" style={{ color: '#15803d' }}>
                <FontAwesomeIcon icon="check" style={{ marginInlineEnd: '0.375rem' }} />
                {t('home.freeDocBanner')}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
